import React from 'react'

const StackContext = React.createContext(undefined)
export default StackContext
